import { render, staticRenderFns } from "./LegacyAuthSmtpService.vue?vue&type=template&id=148b454f&"
import script from "./LegacyAuthSmtpService.vue?vue&type=script&lang=js&"
export * from "./LegacyAuthSmtpService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports